var AbstractAttributesDialog = require("attributes/AbstractAttributesDialog");
var Utils = require("common/Utils");
var PopupDialog = require("common/PopupDialog");
var BrowserMutationObserver = MutationObserver || WebkitMutationObserver;

/**
 * @extends {AbstractAttributesDialog}
 * @class
 */
function TOTPAuthenticationDialog() {
    var $htmlForm = $(require("html!./totp_authentication_dialog.html"));
    AbstractAttributesDialog.call(this, $htmlForm);

    var self = this;

    var uiHelper = require("attributes/AttributesUIHelper");

    var $form = $htmlForm;
    var $submitButton = $form.find("a.attribsDialogContinueBtn");
    var $attrList = $form.find("ul.attrList");

    var $content = self.getContent();
    $content.append($form);

    var $challengeResponseContainer = $content.find(".totpChallengeResponse");

    this.setSubmitEvent("TOTPSettingsDelegate", "post-authentication-credentials");

    // Fiddle fix to make sure pixel alignment is correct and dialog displays without
    // aliasing problems.
    var skipNext = false;
    var mutationObserver = new BrowserMutationObserver(function(mutations) {
        if (skipNext) {
            skipNext = false;
        } else {
            mutations.forEach(function(mutation) {
                var origleft = $(mutation.target).position().left;
                var rndleft = Math.round(origleft);

                if (rndleft !== origleft) {
                    skipNext = true;
                    $(mutation.target).css({left : rndleft});
                }
            });
        }
    });

    function buildAttributes($attrList, attributes, namespace) {
        for (var i = 0; i < attributes.length; i++) {
            var $fieldContainer = $("<li>", {"class" : "attrField", "data-namespace" : namespace});
            uiHelper.createAttributeUI(attributes[i], $fieldContainer, false, namespace);
            $attrList.append($fieldContainer);
        }
    }

    function prepareDialog(requiredAuth, submitAttrs) {
        $attrList.empty();

        if (!$.isEmptyObject(requiredAuth.challenge)) {
            const challengeMsg = "common::" + requiredAuth.challenge.message;

            $challengeResponseContainer.text($.t(challengeMsg, {pin : requiredAuth.challenge.info}));
            $challengeResponseContainer.show();

            var $newListItem = $("<li>", {"class" : "attrField"});

            const label = Utils.getAuthSchemeDisplayLabel(requiredAuth.challenge.scheme);
            var $newListInput = $("<input>", {type : "password", name : requiredAuth.challenge.scheme, placeholder : label});
            $newListItem.append($newListInput);

            if (challengeMsg === "common::radius.resp.acceptPin") {
                $newListInput.val("yes");
                $newListItem.hide();
            }

            $attrList.append($newListItem);
            $submitButton.text($.t("common::login.saveContinue"));
        } else if (requiredAuth.schemes[0]) {
            const session = CudaLaunch.serverConfiguration.getSession();
            const scheme = Object.keys(requiredAuth.schemes[0])[0];
            const label = Utils.getAuthSchemeDisplayLabel(scheme);
            $challengeResponseContainer.text("");
            $challengeResponseContainer.hide();

            const attributes = [
                {
                    id : "username",
                    label : $.t("common::login.username"),
                    value : session.username,
                    format : 0
                }, {
                    id : scheme,
                    label : label,
                    value : "",
                    format : 4
                }
            ];

            buildAttributes($attrList, attributes, "session");
            $submitButton.text($.t("common::continue.title"));
        }

        uiHelper.enhanceAttributesFormItems($attrList, submitAttrs);
        $attrList.listview("refresh");
    }

    this.promptForAttributes = function(requiredAuth) {
        var deferred = $.Deferred();

        console.debug("submitting required launch attributes");

        var submitAttrs = function() {
            self.submitAttributes("", deferred, function() {});
        };

        prepareDialog(requiredAuth, submitAttrs);

        $submitButton.off("click.submitAttrs");
        $submitButton.on("click.submitAttrs", submitAttrs);

        // Register close handler to reject the deferred in the case that the user closed the popup
        $content.on("popupafterclose.rejectDeferred", function() {
            $content.off("popupafterclose.rejectDeferred");
            deferred.reject();
        });

        self.setTitle($.t("common::auth.prompt.title"));

        // Ensure the mutationObserver is watching the dialog
        $(".popupContainer").each(function() {
            mutationObserver.observe(this,
                {attributes : true, childList : false, characterData : false, subtree : false});
        });

        PopupDialog.showPopup($content);

        return deferred.promise();
    };
}

Utils.inherits(TOTPAuthenticationDialog, AbstractAttributesDialog);

module.exports = TOTPAuthenticationDialog;